module.exports = __webpack_public_path__ + "static/media/design-thinking.d3ee0c24.svg";